import { DpLinkText } from '@/components/blocks/DpLibrary/DpFooterLinks/style';
import { combineSX } from '@/utils/combineSX';
import Link, { LinkBaseProps } from '@mui/material/Link';

export const DpFooterLinks = ({ sx, ...props }: LinkBaseProps) => (
	<Link sx={combineSX([DpLinkText, ...(Array.isArray(sx) ? sx : [sx])])} {...props}></Link>
);
